module.exports = "images/france-tv.393fe4da.png";